import React, { useEffect } from "react";
import { css } from "@emotion/react";
import f from "@/module/Utils/emotion";
import defaultAnimation from "@/module/sketch/defaultAnimation";
import Util from "@/module/Utils/Util";
import { globFunc } from "@/store";
import p5 from "p5";

class Background extends React.Component<any, any> {
  private sketch: any;
  private shaderCanvas: any;
  private readonly canvasRef: React.MutableRefObject<HTMLDivElement>;

  constructor(props) {
    super(props);
    this.sketch = null;
    this.shaderCanvas = null;
    this.canvasRef = React.createRef<HTMLDivElement>();
  }

  setHeight = () => {
    if (Util.isPC()) {
      this.canvasRef.current.style.height = "";
    } else {
      this.canvasRef.current.style.height = `${screen.availHeight}px`;
    }
  };

  componentDidMount = () => {
    this.setHeight();
    window.addEventListener("resize", this.setHeight);
    if (typeof window !== "undefined") {
      const p5 = require("p5");
      globFunc.dispatch({
        type: "addOpenEye",
        func: new p5(defaultAnimation),
      });
    }
  };

  componentWillUnmount = () => {
    globFunc.getState().sketch.destroy();
    window.removeEventListener("resize", this.setHeight);
  };

  render() {
    return <div id={"bg"} css={deleteEventsAnyWay} ref={this.canvasRef}></div>;
  }
}

const deleteEventsAnyWay = css({
  pointerEvents: "none",
  userSelect: "none",
  [f.pc()]: {
    height: "100vh",
  },
  canvas: {
    width: "100%!important",
    height: "100%!important",
  },
});

export default Background;
